import React, { Component } from 'react';
import payment              from '../../lib/jquery.payment';
import classNames           from 'classnames/bind';
import TabContainer         from '../generic/tab-container';
import TabPane              from '../generic/tab-pane';

export default class RegisterSubscription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            planType             : {
                web           : true,
                webPlusMobile : false
            },
            selectedSubscription : 'monthly'
        };
    }

    enableWeb = () => {
        const planType = {
            web           : true,
            webPlusMobile : false
        };
        this.setState({ planType }, () => {
            this.props.updateParentField("planType", this.state.planType);
        });
    }

    enableWebMobile = () => {
        const planType = {
            web           : false,
            webPlusMobile : true
        };
        this.setState({ planType }, () => {
            this.props.updateParentField("planType", this.state.planType);
        });
    }

    handleOptionChange = (e) => {
        this.setState({selectedSubscription : e.target.value}, () => {
            this.props.updateParentField("subscriptionType", this.state.selectedSubscription);
        });
    }

    render() {
        let webBtnStyle           = classNames('btn',{'btn-sub':!this.state.planType.web},{'btn-sub-active':this.state.planType.web});
        let webPlusMobileBtnStyle = classNames('btn',{'btn-sub':!this.state.planType.webPlusMobile},{'btn-sub-active':this.state.planType.webPlusMobile});

        let RegisterSubscriptionComp = (
                <div className="row">
                    <div className="col-md-12" style={{ marginLeft:50, marginRight:50 }}>
                        <br/>
                        <h3>Select Product</h3>
                        <br/>
                        <fieldset>
                          <div className="text-center">
                              <button
                                  type      = "button"
                                  className = {webBtnStyle}
                                  onClick   = {this.enableWeb}
                              >
                                  Web
                              </button>
                              <button
                                  type      = "button"
                                  className = {webPlusMobileBtnStyle}
                                  onClick   = {this.enableWebMobile}
                              >
                                  {"Web + Mobile"}
                              </button>
                          </div>
                        </fieldset>
                    </div>

                    <div className="col-md-12 payment-plan" style={{ marginLeft:50, marginRight:50 }}>
                        <br/>
                        <h3>Choose Payment Plan</h3>
                        <br/>
                        <fieldset>
                          <div className="text-center">
                            <label className="radio-inline">
                                <input
                                    type     = "radio"
                                    name     = "subscriptionOptions"
                                    id       = "iR1"
                                    value    = "monthly"
                                    checked  = {this.state.selectedSubscription === 'monthly'}
                                    onChange = {this.handleOptionChange}
                                /> Monthly Plan
                            </label>
                            <label className="radio-inline">
                                <input
                                    type     = "radio"
                                    name     = "subscriptionOptions"
                                    id       = "iR2"
                                    value    = "oneYear"
                                    checked  = {this.state.selectedSubscription === 'oneYear'}
                                    onChange = {this.handleOptionChange}
                                /> Annual Plan
                            </label>
                            <label className="radio-inline">
                                <input
                                    type     = "radio"
                                    name     = "subscriptionOptions"
                                    id       = "iR3"
                                    value    = "twoYear"
                                    checked  = {this.state.selectedSubscription === 'twoYear'}
                                    onChange = {this.handleOptionChange}
                                /> Two Year Plan
                            </label>
                          </div>
                        </fieldset>
                    </div>

                    <div className="col-md-12" style={{ marginLeft:50, marginRight:50 }}>
                        <div className = "center-block plan-info">
                            {
                                this.state.selectedSubscription === 'monthly'
                                    ? (
                                        <div className="plan-info-text">
                                            Billed monthly. Your set up fee and first month payment will be processed with in 3 business days. Plan term starts 2 weeks from today.
                                        </div>
                                        )
                                    : null
                            }
                            {
                                this.state.selectedSubscription === 'oneYear'
                                    ? (
                                        <div className="plan-info-text">
                                            Paid up-front for 1 year. Payment will be processed with in 3 business days. Plan term starts 2 weeks from today.
                                        </div>
                                        )
                                    : null
                            }
                            {
                                this.state.selectedSubscription === 'twoYear'
                                    ? (
                                        <div className="plan-info-text">
                                            Paid up-front for 2 years. Payment will be processed with in 3 business days. Plan term starts 2 weeks from today.
                                        </div>
                                        )
                                    : null
                            }
                        </div>
                    </div>
                </div>
            );
            return  RegisterSubscriptionComp;
    }
}



// WEBPACK FOOTER //
// src/components/register/RegisterSubscription.js